import { Link } from "react-router-dom";
import MetisMenu from '@metismenu/react';

export default function SideBar(){
    const SideBarRemove = () => {
        document.body.classList.remove('on-side');
    };
    return(
        <aside className="slide-bar off-canvas">
		<div className="close-mobile-menu"  onClick={SideBarRemove}>
			<i className="fas fa-times"></i>
		</div>
		
		<div className="offset-sidebar">
			<div className="offset-widget offset-logo mb-30">
				<Link to="index.html">
					<img src="assets/img/logo/header-logo-1.png" alt="logo" />
				</Link>
			</div>
			<div className="offset-widget mb-40">
				<div className="info-widget">
					<p className="mb-30">
						We help our clients succeed by
						creating brand identities, digital
						IT experiences, & print materials.
						Helping our clients reach their
						full potential on the market.
					</p>
					<div className="offset-social-link">
						<div className="social-icons">
							<Link className="fb" href="#" target="_blank"><i className="fab fa-facebook-f"></i></Link>
							<Link className="ttr" href="#" target="_blank"><i className="fab fa-twitter"></i></Link>
							<Link className="yh" href="#" target="_blank"><i className="fab fa-yahoo"></i></Link>
							<Link className="yt" href="#" target="_blank"><i className="fab fa-youtube"></i></Link>
						</div>
					</div>
					<div className="slidebar-address">
						<span>Get is touch</span>
						<p>2307 Beverley Rd
							Brooklyn, New York 11226
							United States.
							789 098 098 09</p>
					</div>
					<Link className="theme_btn theme_btn_bg offset-sidebar-btn" href="contact.html">Contact Us <i
							className="fas fa-long-arrow-right"></i></Link>
				</div>
			</div>
			<div className="offset-sidebar-bg"><img src="assets/img/pattern/offset-sidebar-bg.png" alt="" /></div>
		</div>
	
		<nav className="side-mobile-menu">
			<MetisMenu id="mobile-menu-active">
				<li className="has-dropdown">
					<Link href="index.html">Home</Link>
					<ul className="sub-menu">
						<li className="has-dropdown">
							<Link to="#">Multipage</Link>
							<ul className="sub-menu">
								<li><Link to="/home">Home Style 1</Link></li>
								<li><Link to="/home-2">Home Style 2</Link></li>
								<li><Link to="/home-3">Home Style 3</Link></li>
								<li><Link to="/home-4">Home Style 4</Link></li>
								<li><Link to="/home-5">Home Style 5</Link></li>								
							</ul>
						</li>
						<li className="has-dropdown">
							<Link to="#">Onepage</Link>
							<ul className="sub-menu">
								<li><Link to="/onepage-1">Onepage Style 1</Link></li>
								<li><Link to="/onepage-2">Onepage Style 2</Link></li>
								<li><Link to="/onepage-3">Onepage Style 3</Link></li>								
							</ul>
						</li>						
					</ul>
				</li>
				<li className="has-dropdown">
					<Link to="services">Services</Link>
					<ul className="sub-menu">
						<li className="has-dropdown">
							<Link to="/services">Services</Link>							
						</li>
						<li><Link to="services-details">Services Details</Link></li>
					</ul>
				</li>
				<li><Link to="/about">About</Link></li>
				<li className="has-dropdown">
					<Link to="#">Pages</Link>
					<ul className="sub-menu">
						<li><Link to="/team">Team</Link></li>
						<li><Link to="/team-details">Team Details</Link></li>
						<li><Link to="/portfolio">Portfolio</Link></li>
						<li><Link to="/case-details">Case Details</Link></li>
						<li><Link to="/Price">Pricing</Link></li>
						<li><Link to="/history">Our History</Link></li>
						<li><Link to="/faq">Faq</Link></li>
					</ul>
				</li>
				<li className="has-dropdown">
					<Link to="news">News</Link>
					<ul className="sub-menu">
						<li><Link to="/news">News</Link></li>
						<li><Link to="/news-details">News Details</Link></li>
					</ul>
				</li>
				<li><Link to="/contact">Contact</Link></li>
			</MetisMenu>
		</nav>
		
	</aside>
    )
}